import { ArrCloneHelper, ArrConcatHelper, ArrEveryFuncHelper, ArrEveryHelper, ArrFilterFuncHelper, ArrFilterHelper, ArrFindHelper, ArrForEachFuncHelper, ArrForEachHelper, ArrLeftHelper, ArrMapFuncHelper, ArrMapHelper, ArrRangeHelper, ArrReduceFuncHelper, ArrReduceHelper, ArrSomeFuncHelper, ArrSomeHelper, ArrToStringHelper, ExtendArrHelper, } from './arr';
import { ArrayBindingHelper, ObjectBindingHelper } from './bind';
import { BufferSliceHelper } from './buffer';
import { GetCachedValueHelper, GetCacheHelper } from './cache';
import { CreateClassHelper } from './class';
import { ArrSliceHelper, CloneArrayHelper, ConsoleLogHelper, DebugLogHelper, ExpHelper, GenericLogSerializeHelper, } from './common';
import { BreakHelper, ContinueHelper, HandleCompletionHelper, ReturnHelper, ThrowCompletionBaseHelper, ThrowCompletionHelper, ThrowHelper, } from './completionRecord';
import { ApplicationMatchesVerificationHelper, CompleteSendHelper, DeployHelper, DidReceiveAssetsHelper, DidReceiveNonClaimAssetsHelper, DidSendAssetsHelper, GetOutputAssetValueMapHelper, GetSmartContractPropertyHelper, HandleNormalHelper, HandleReceiveHelper, HandleSendHelper, HandleSendUnsafeHelper, InvocationIsCallerHelper, InvokeSmartContractHelper, InvokeSmartContractMethodHelper, IsCallerHelper, IsClaimedTransactionHelper, IsDeployedHelper, IsProcessedTransactionHelper, MergeAssetValueMapsHelper, RefundAssetsHelper, SetDeployedHelper, SetProcessedTransactionHelper, UpgradeHelper, } from './contract';
import { ThrowTypeErrorHelper } from './error';
import { ArgumentsHelper, BindFunctionThisHelper, CallHelper, CallLikeHelper, CloneFunctionHelper, CreateCallArrayHelper, CreateConstructArrayHelper, CreateFunctionArrayHelper, CreateFunctionObjectHelper, FunctionHelper, FunctionLikeHelper, GetCallableHelper, InvokeCallHelper, InvokeConstructHelper, NewHelper, ParametersHelper, } from './function';
import { CreateGlobalObjectHelper, GetArgumentHelper, GetGlobalPropertyHelper, } from './global';
import { CreateEnumeratorIterableIteratorHelper, CreateIterableIteratorBaseHelper, CreateIteratorIterableIteratorHelper, IterableIteratorForEachHelper, IterableIteratorReduceHelper, } from './iterableIterator';
import { RawEnumeratorEveryHelper, RawEnumeratorFilterHelper, RawEnumeratorFindHelper, RawEnumeratorForEachFuncHelper, RawEnumeratorForEachHelper, RawEnumeratorReduceHelper, RawEnumeratorSomeHelper, RawIteratorEveryBaseHelper, RawIteratorEveryHelper, RawIteratorForEachBaseHelper, RawIteratorForEachFuncBaseHelper, RawIteratorForEachFuncHelper, RawIteratorForEachHelper, RawIteratorForEachKeyHelper, RawIteratorReduceBaseHelper, RawIteratorReduceHelper, RawIteratorSomeBaseHelper, RawIteratorSomeHelper, } from './iterator';
import { CreateIteratorResultHelper } from './iteratorResult';
import { MapDeleteHelper, MapEveryHelper, MapFilterHelper, MapForEachHelper, MapMapHelper, MapReduceHelper, MapSomeHelper, } from './map';
import { AddEmptyModuleHelper, ExportHelper, ExportSingleHelper, GetCurrentModuleHelper, GetModuleHelper, GetModulesHelper, } from './module';
import { EqualsEqualsEqualsHelper, EqualsEqualsHelper, LessThanHelper, } from './relational';
import { CaseHelper, ForLoopHelper, IfHelper, ProcessStatementsHelper, } from './statement';
import { AtStructuredStorageHelper, CacheStorageHelper, CommonStorageHelper, CreateIterableIteratorStructuredStorageBaseHelper, CreateIterableIteratorStructuredStorageHelper, CreateIteratorStructuredStorageHelper, CreateKeyIterableIteratorStructuredStorageHelper, CreateStructuredStorageHelper, CreateValIterableIteratorStructuredStorageHelper, DeleteCacheStorageHelper, DeleteStorageBaseHelper, DeleteStorageHelper, DeleteStructuredStorageHelper, ForEachFuncStructuredStorageBaseHelper, ForEachFuncStructuredStorageHelper, ForEachKeyFuncStructuredStorageHelper, ForEachKeyStructuredStorageHelper, ForEachStructuredStorageBaseHelper, ForEachStructuredStorageHelper, ForEachValStructuredStorageHelper, GetArrayStorageLengthHelper, GetCommonStorageHelper, GetKeyStructuredStorageHelper, GetStorageBaseHelper, GetStorageHelper, GetStructuredStorageHelper, GetStructuredStorageSizeHelper, HandlePrefixArrayStructuredStorageHelper, HandlePrefixKeyStructuredStorageHelper, HandleUndefinedStorageHelper, HandleValueStructuredStorageHelper, HandleValValueStructuredStorageHelper, HasStructuredStorageHelper, IterStorageHelper, PutArrayStorageLengthHelper, PutCommonStorageHelper, PutStorageHelper, SetArrayStorageHelper, SetStructuredStorageHelper, StructuredStorageReduceBaseHelper, StructuredStorageReduceHelper, StructuredStorageReduceValHelper, UnwrapKeyStructuredStorageHelper, } from './storage';
import { ArrayLengthHelper, BufferLengthHelper, ConcatBufferHelper, CreateArrayHelper, CreateObjectHelper, CreatePropertyObjectHelper, FindObjectPropertyHelper, FindObjectPropertyHelperBase, ForBuiltinTypeHelper, ForIterableTypeHelper, ForTypeHelper, GetArrayIndexHelper, GetBufferIndexHelper, GetInternalObjectHelper, GetInternalObjectPropertyHelper, GetObjectHelper, GetPropertyObjectHelper, GetPropertyObjectKeysHelper, GetPropertyObjectPropertyHelper, GetPropertyObjectValuesHelper, GetSymbolObjectHelper, GetSymbolObjectPropertyHelper, InObjectPropertyHelper, InPropertyObjectPropertyHelper, InstanceofHelper, InSymbolObjectPropertyHelper, IsArrayHelper, IsArrayStorageHelper, IsAttributeHelper, IsBooleanHelper, IsBufferHelper, IsErrorHelper, IsForwardValueHelper, IsInputHelper, IsIterableHelper, IsIterableIteratorHelper, IsIteratorResultHelper, IsMapHelper, IsMapStorageHelper, IsNullHelper, IsNullOrUndefinedHelper, IsNumberHelper, IsObjectHelper, IsOutputHelper, IsSetHelper, IsSetStorageHelper, IsStringHelper, IsSymbolHelper, IsTransactionHelper, IsUndefinedHelper, OmitObjectPropertiesHelper, OmitPropertyObjectPropertiesHelper, OmitSymbolObjectPropertiesHelper, PackObjectHelper, PickObjectPropertiesHelper, PickPropertyObjectPropertiesHelper, PickSymbolObjectPropertiesHelper, SetAccessorPropertyObjectPropertyHelper, SetAccessorSymbolObjectPropertyHelper, SetArrayIndexHelper, SetDataPropertyObjectPropertyHelper, SetDataSymbolObjectPropertyHelper, SetInternalObjectPropertyHelper, SetPropertyObjectPropertyHelper, SetSymbolObjectPropertyHelper, ToBooleanHelper, ToNullishBooleanHelper, ToNumberHelper, ToObjectHelper, ToPrimitiveHelper, ToStringHelper, UnwrapArrayHelper, UnwrapArrayStorageHelper, UnwrapAttributeHelper, UnwrapBooleanHelper, UnwrapBufferHelper, UnwrapErrorHelper, UnwrapForwardValueHelper, UnwrapInputHelper, UnwrapIterableIteratorHelper, UnwrapIteratorResultHelper, UnwrapMapHelper, UnwrapMapStorageHelper, UnwrapNumberHelper, UnwrapObjectHelper, UnwrapOutputHelper, UnwrapSetHelper, UnwrapSetStorageHelper, UnwrapStringHelper, UnwrapSymbolHelper, UnwrapTransactionHelper, UnwrapValHelper, UnwrapValRecursiveHelper, WrapArrayHelper, WrapArrayStorageHelper, WrapArrayValHelper, WrapAttributeHelper, WrapBooleanHelper, WrapBufferHelper, WrapErrorHelper, WrapForwardValueHelper, WrapInputHelper, WrapIterableIteratorHelper, WrapIteratorResultHelper, WrapMapHelper, WrapMapStorageHelper, WrapNullHelper, WrapNumberHelper, WrapObjectHelper, WrapOutputHelper, WrapSetHelper, WrapSetStorageHelper, WrapStringHelper, WrapSymbolHelper, WrapTransactionHelper, WrapUndefinedHelper, WrapValHelper, WrapValRecursiveHelper, } from './types';
import { IsAccountHelper, UnwrapAccountHelper, WrapAccountHelper } from './types/account';
import { IsAssetHelper, UnwrapAssetHelper, WrapAssetHelper } from './types/asset';
import { IsBlockHelper, UnwrapBlockHelper, WrapBlockHelper } from './types/block';
import { IsContractHelper, UnwrapContractHelper, WrapContractHelper } from './types/contract';
import { IsHeaderHelper, UnwrapHeaderHelper, WrapHeaderHelper } from './types/header';
export const createHelpers = (prevHelpers) => {
    const mutableCache = prevHelpers === undefined ? {} : prevHelpers.mutableCache;
    function memoized(helperClass) {
        return (options) => {
            const key = helperClass.getKey(options);
            let value = mutableCache[key];
            if (value === undefined) {
                mutableCache[key] = value = new helperClass(options);
            }
            return value;
        };
    }
    const mutableUniqueCache = {};
    function memoizedUnique(helperClass) {
        return (options) => {
            const key = helperClass.getKey(options);
            let value = mutableUniqueCache[key];
            if (value === undefined) {
                mutableUniqueCache[key] = value = new helperClass(options);
            }
            return value;
        };
    }
    return {
        mutableCache,
        isAccount: new IsAccountHelper(),
        wrapAccount: new WrapAccountHelper(),
        unwrapAccount: new UnwrapAccountHelper(),
        arrClone: new ArrCloneHelper(),
        arrConcat: new ArrConcatHelper(),
        arrEvery: (options) => new ArrEveryHelper(options),
        arrEveryFunc: new ArrEveryFuncHelper(),
        arrFind: (options) => new ArrFindHelper(options),
        arrFilter: (options) => new ArrFilterHelper(options),
        arrFilterFunc: new ArrFilterFuncHelper(),
        arrLeft: new ArrLeftHelper(),
        arrMap: (options) => new ArrMapHelper(options),
        arrMapFunc: new ArrMapFuncHelper(),
        arrForEach: (options) => new ArrForEachHelper(options),
        arrForEachFunc: new ArrForEachFuncHelper(),
        arrRange: (options) => new ArrRangeHelper(options),
        arrReduce: (options) => new ArrReduceHelper(options),
        arrReduceFunc: new ArrReduceFuncHelper(),
        arrSomeFunc: new ArrSomeFuncHelper(),
        arrSome: (options) => new ArrSomeHelper(options),
        arrToString: (options) => new ArrToStringHelper(options),
        extendArr: new ExtendArrHelper(),
        isAsset: new IsAssetHelper(),
        wrapAsset: new WrapAssetHelper(),
        unwrapAsset: new UnwrapAssetHelper(),
        arrayBinding: (options) => new ArrayBindingHelper(options),
        objectBinding: (options) => new ObjectBindingHelper(options),
        bufferSlice: (options) => new BufferSliceHelper(options),
        isBlock: new IsBlockHelper(),
        wrapBlock: new WrapBlockHelper(),
        unwrapBlock: new UnwrapBlockHelper(),
        getCachedValue: (options) => new GetCachedValueHelper(options),
        getCache: new GetCacheHelper(),
        createClass: (options) => new CreateClassHelper(options),
        didReceiveAssets: new DidReceiveAssetsHelper(),
        didReceiveNonClaimAssets: new DidReceiveNonClaimAssetsHelper(),
        didSendAssets: new DidSendAssetsHelper(),
        invokeSmartContract: (options) => new InvokeSmartContractHelper(options),
        invokeSmartContractMethod: (options) => new InvokeSmartContractMethodHelper(options),
        getOutputAssetValueMap: new GetOutputAssetValueMapHelper(),
        invocationIsCaller: new InvocationIsCallerHelper(),
        isCaller: new IsCallerHelper(),
        isProcessedTransaction: new IsProcessedTransactionHelper(),
        refundAssets: new RefundAssetsHelper(),
        mergeAssetValueMaps: (options) => new MergeAssetValueMapsHelper(options),
        getSmartContractProperty: (options) => new GetSmartContractPropertyHelper(options),
        isDeployed: new IsDeployedHelper(),
        setDeployed: new SetDeployedHelper(),
        isClaimedTransaction: new IsClaimedTransactionHelper(),
        setProcessedTransaction: new SetProcessedTransactionHelper(),
        completeSend: new CompleteSendHelper(),
        deploy: (options) => new DeployHelper(options),
        upgrade: (options) => new UpgradeHelper(options),
        handleNormal: memoizedUnique(HandleNormalHelper),
        handleSend: (options) => new HandleSendHelper(options),
        handleReceive: (options) => new HandleReceiveHelper(options),
        handleSendUnsafe: (options) => new HandleSendUnsafeHelper(options),
        applicationMatchesVerification: new ApplicationMatchesVerificationHelper(),
        isContract: new IsContractHelper(),
        wrapContract: new WrapContractHelper(),
        unwrapContract: new UnwrapContractHelper(),
        arrSlice: (options = {}) => new ArrSliceHelper(options),
        cloneArray: new CloneArrayHelper(),
        forType: (options) => new ForTypeHelper(options),
        genericLogSerialize: new GenericLogSerializeHelper(),
        exp: new ExpHelper(),
        consoleLog: new ConsoleLogHelper(),
        debugLog: (options) => new DebugLogHelper(options),
        equalsEqualsEquals: (options) => new EqualsEqualsEqualsHelper(options),
        equalsEquals: (options) => new EqualsEqualsHelper(options),
        lessThan: (options) => new LessThanHelper(options),
        processStatements: (options) => new ProcessStatementsHelper(options),
        args: new ArgumentsHelper(),
        bindFunctionThis: (options) => new BindFunctionThisHelper(options),
        call: new CallHelper(),
        callLike: new CallLikeHelper(),
        cloneFunction: new CloneFunctionHelper(),
        createCallArray: new CreateCallArrayHelper(),
        createConstructArray: (options) => new CreateConstructArrayHelper(options),
        createFunctionArray: (options) => new CreateFunctionArrayHelper(options),
        createFunctionObject: (options) => new CreateFunctionObjectHelper(options),
        function: (options) => new FunctionHelper(options),
        functionLike: new FunctionLikeHelper(),
        getCallable: memoized(GetCallableHelper),
        invokeCall: memoized(InvokeCallHelper),
        invokeConstruct: (options) => new InvokeConstructHelper(options),
        new: (options) => new NewHelper(options),
        parameters: (options) => new ParametersHelper(options),
        forLoop: (options) => new ForLoopHelper(options),
        if: (options) => new IfHelper(options),
        case: (cases, defaultCase) => new CaseHelper(cases, defaultCase),
        handleCompletion: new HandleCompletionHelper(),
        return: new ReturnHelper(),
        throw: new ThrowHelper(),
        break: new BreakHelper(),
        continue: new ContinueHelper(),
        throwCompletion: new ThrowCompletionHelper(),
        throwCompletionBase: new ThrowCompletionBaseHelper(),
        throwTypeError: new ThrowTypeErrorHelper(),
        wrapBoolean: new WrapBooleanHelper(),
        wrapNull: new WrapNullHelper(),
        wrapNumber: new WrapNumberHelper(),
        createObject: new CreateObjectHelper(),
        wrapString: new WrapStringHelper(),
        wrapSymbol: new WrapSymbolHelper(),
        wrapUndefined: new WrapUndefinedHelper(),
        isBoolean: new IsBooleanHelper(),
        isNull: new IsNullHelper(),
        isNumber: new IsNumberHelper(),
        isObject: new IsObjectHelper(),
        isString: new IsStringHelper(),
        isSymbol: new IsSymbolHelper(),
        isUndefined: new IsUndefinedHelper(),
        isNullOrUndefined: (options) => new IsNullOrUndefinedHelper(options),
        unwrapBoolean: new UnwrapBooleanHelper(),
        unwrapNumber: new UnwrapNumberHelper(),
        unwrapString: new UnwrapStringHelper(),
        unwrapSymbol: new UnwrapSymbolHelper(),
        getObject: new GetObjectHelper(),
        toBoolean: (options) => new ToBooleanHelper(options),
        toNullishBoolean: (options) => new ToNullishBooleanHelper(options),
        toString: (options) => new ToStringHelper(options),
        toNumber: (options) => new ToNumberHelper(options),
        toObject: (options) => new ToObjectHelper(options),
        toPrimitive: (options) => new ToPrimitiveHelper(options),
        getSymbolObject: new GetSymbolObjectHelper(),
        getSymbolObjectProperty: new GetSymbolObjectPropertyHelper(),
        setSymbolObjectProperty: new SetSymbolObjectPropertyHelper(),
        setDataSymbolObjectProperty: new SetDataSymbolObjectPropertyHelper(),
        setAccessorSymbolObjectProperty: (options) => new SetAccessorSymbolObjectPropertyHelper(options),
        getPropertyObject: new GetPropertyObjectHelper(),
        getPropertyObjectKeys: new GetPropertyObjectKeysHelper(),
        getPropertyObjectValues: new GetPropertyObjectValuesHelper(),
        getPropertyObjectProperty: new GetPropertyObjectPropertyHelper(),
        setPropertyObjectProperty: new SetPropertyObjectPropertyHelper(),
        setDataPropertyObjectProperty: new SetDataPropertyObjectPropertyHelper(),
        setAccessorPropertyObjectProperty: (options) => new SetAccessorPropertyObjectPropertyHelper(options),
        getInternalObject: new GetInternalObjectHelper(),
        getInternalObjectProperty: new GetInternalObjectPropertyHelper(),
        setInternalObjectProperty: new SetInternalObjectPropertyHelper(),
        packObject: new PackObjectHelper(),
        pickObjectProperties: new PickObjectPropertiesHelper(),
        pickPropertyObjectProperties: new PickPropertyObjectPropertiesHelper(),
        pickSymbolObjectProperties: new PickSymbolObjectPropertiesHelper(),
        omitObjectProperties: new OmitObjectPropertiesHelper(),
        omitPropertyObjectProperties: new OmitPropertyObjectPropertiesHelper(),
        omitSymbolObjectProperties: new OmitSymbolObjectPropertiesHelper(),
        wrapObject: new WrapObjectHelper(),
        unwrapObject: new UnwrapObjectHelper(),
        instanceof: new InstanceofHelper(),
        inObjectProperty: (options) => new InObjectPropertyHelper(options),
        inPropertyObjectProperty: new InPropertyObjectPropertyHelper(),
        inSymbolObjectProperty: new InSymbolObjectPropertyHelper(),
        createPropertyObject: new CreatePropertyObjectHelper(),
        findObjectProperty: (options) => new FindObjectPropertyHelper(options),
        findObjectPropertyBase: (options) => new FindObjectPropertyHelperBase(options),
        isHeader: new IsHeaderHelper(),
        wrapHeader: new WrapHeaderHelper(),
        unwrapHeader: new UnwrapHeaderHelper(),
        iterableIteratorForEach: (options) => new IterableIteratorForEachHelper(options),
        iterableIteratorReduce: (options) => new IterableIteratorReduceHelper(options),
        createEnumeratorIterableIterator: (options) => new CreateEnumeratorIterableIteratorHelper(options),
        createIterableIteratorBase: (options) => new CreateIterableIteratorBaseHelper(options),
        createIteratorIterableIterator: (options) => new CreateIteratorIterableIteratorHelper(options),
        rawIteratorEvery: (options) => new RawIteratorEveryHelper(options),
        rawIteratorEveryBase: (options) => new RawIteratorEveryBaseHelper(options),
        rawIteratorSome: (options) => new RawIteratorSomeHelper(options),
        rawIteratorSomeBase: (options) => new RawIteratorSomeBaseHelper(options),
        rawIteratorForEach: (options) => new RawIteratorForEachHelper(options),
        rawIteratorForEachKey: (options) => new RawIteratorForEachKeyHelper(options),
        rawIteratorForEachBase: (options) => new RawIteratorForEachBaseHelper(options),
        rawIteratorForEachFunc: new RawIteratorForEachFuncHelper(),
        rawIteratorForEachFuncBase: (options) => new RawIteratorForEachFuncBaseHelper(options),
        rawEnumeratorForEachFunc: new RawEnumeratorForEachFuncHelper(),
        rawEnumeratorForEach: (options) => new RawEnumeratorForEachHelper(options),
        rawEnumeratorFilter: (options) => new RawEnumeratorFilterHelper(options),
        rawEnumeratorFind: (options) => new RawEnumeratorFindHelper(options),
        rawEnumeratorReduce: (options) => new RawEnumeratorReduceHelper(options),
        rawEnumeratorEvery: (options) => new RawEnumeratorEveryHelper(options),
        rawEnumeratorSome: (options) => new RawEnumeratorSomeHelper(options),
        rawIteratorReduce: (options) => new RawIteratorReduceHelper(options),
        rawIteratorReduceBase: (options) => new RawIteratorReduceBaseHelper(options),
        createIteratorResult: new CreateIteratorResultHelper(),
        mapDelete: new MapDeleteHelper(),
        mapEvery: (options) => new MapEveryHelper(options),
        mapForEach: (options) => new MapForEachHelper(options),
        mapFilter: (options) => new MapFilterHelper(options),
        mapMap: (options) => new MapMapHelper(options),
        mapReduce: (options) => new MapReduceHelper(options),
        mapSome: (options) => new MapSomeHelper(options),
        cacheStorage: new CacheStorageHelper(),
        putCommonStorage: new PutCommonStorageHelper(),
        handleUndefinedStorage: (options) => new HandleUndefinedStorageHelper(options),
        commonStorage: new CommonStorageHelper(),
        deleteCacheStorage: new DeleteCacheStorageHelper(),
        deleteStorageBase: new DeleteStorageBaseHelper(),
        deleteStorage: new DeleteStorageHelper(),
        iterStorage: new IterStorageHelper(),
        putStorage: new PutStorageHelper(),
        getStorageBase: new GetStorageBaseHelper(),
        getStorage: new GetStorageHelper(),
        getCommonStorage: new GetCommonStorageHelper(),
        atStructuredStorage: (options) => new AtStructuredStorageHelper(options),
        createIteratorStructuredStorage: (options) => new CreateIteratorStructuredStorageHelper(options),
        createStructuredStorage: (options) => new CreateStructuredStorageHelper(options),
        deleteStructuredStorage: (options) => new DeleteStructuredStorageHelper(options),
        getKeyStructuredStorage: (options) => new GetKeyStructuredStorageHelper(options),
        getStructuredStorage: (options) => new GetStructuredStorageHelper(options),
        hasStructuredStorage: (options) => new HasStructuredStorageHelper(options),
        setStructuredStorage: (options) => new SetStructuredStorageHelper(options),
        setArrayStorage: new SetArrayStorageHelper(),
        forEachFuncStructuredStorageBase: (options) => new ForEachFuncStructuredStorageBaseHelper(options),
        forEachFuncStructuredStorage: (options) => new ForEachFuncStructuredStorageHelper(options),
        forEachKeyFuncStructuredStorage: (options) => new ForEachKeyFuncStructuredStorageHelper(options),
        forEachStructuredStorageBase: (options) => new ForEachStructuredStorageBaseHelper(options),
        forEachKeyStructuredStorage: (options) => new ForEachKeyStructuredStorageHelper(options),
        forEachStructuredStorage: (options) => new ForEachStructuredStorageHelper(options),
        forEachValStructuredStorage: (options) => new ForEachValStructuredStorageHelper(options),
        getStructuredStorageSize: (options) => new GetStructuredStorageSizeHelper(options),
        handleValueStructuredStorage: new HandleValueStructuredStorageHelper(),
        handleValValueStructuredStorage: new HandleValValueStructuredStorageHelper(),
        handlePrefixKeyStructuredStorage: new HandlePrefixKeyStructuredStorageHelper(),
        createIterableIteratorStructuredStorageBase: (options) => new CreateIterableIteratorStructuredStorageBaseHelper(options),
        createIterableIteratorStructuredStorage: (options) => new CreateIterableIteratorStructuredStorageHelper(options),
        createKeyIterableIteratorStructuredStorage: (options) => new CreateKeyIterableIteratorStructuredStorageHelper(options),
        createValIterableIteratorStructuredStorage: (options) => new CreateValIterableIteratorStructuredStorageHelper(options),
        getArrayStorageLength: new GetArrayStorageLengthHelper(),
        putArrayStorageLength: new PutArrayStorageLengthHelper(),
        handlePrefixArrayStructuredStorage: new HandlePrefixArrayStructuredStorageHelper(),
        unwrapKeyStructuredStorage: (options) => new UnwrapKeyStructuredStorageHelper(options),
        structuredStorageReduceBase: (options) => new StructuredStorageReduceBaseHelper(options),
        structuredStorageReduce: (options) => new StructuredStorageReduceHelper(options),
        structuredStorageReduceVal: (options) => new StructuredStorageReduceValHelper(options),
        forBuiltinType: (options) => new ForBuiltinTypeHelper(options),
        forIterableType: (options) => new ForIterableTypeHelper(options),
        unwrapVal: (options) => new UnwrapValHelper(options),
        wrapVal: (options) => new WrapValHelper(options),
        wrapArrayVal: (options) => new WrapArrayValHelper(options),
        unwrapValRecursive: (options) => new UnwrapValRecursiveHelper(options),
        wrapValRecursive: (options) => new WrapValRecursiveHelper(options),
        arrayLength: new ArrayLengthHelper(),
        createArray: new CreateArrayHelper(),
        getArrayIndex: new GetArrayIndexHelper(),
        setArrayIndex: new SetArrayIndexHelper(),
        wrapArray: new WrapArrayHelper(),
        unwrapArray: new UnwrapArrayHelper(),
        isArray: new IsArrayHelper(),
        wrapArrayStorage: new WrapArrayStorageHelper(),
        unwrapArrayStorage: new UnwrapArrayStorageHelper(),
        isArrayStorage: new IsArrayStorageHelper(),
        wrapAttribute: new WrapAttributeHelper(),
        unwrapAttribute: new UnwrapAttributeHelper(),
        isAttribute: new IsAttributeHelper(),
        bufferLength: new BufferLengthHelper(),
        concatBuffer: new ConcatBufferHelper(),
        getBufferIndex: new GetBufferIndexHelper(),
        createBuffer: new WrapBufferHelper(),
        isBuffer: new IsBufferHelper(),
        unwrapBuffer: new UnwrapBufferHelper(),
        wrapBuffer: new WrapBufferHelper(),
        wrapError: new WrapErrorHelper(),
        unwrapError: new UnwrapErrorHelper(),
        isError: new IsErrorHelper(),
        wrapForwardValue: new WrapForwardValueHelper(),
        unwrapForwardValue: new UnwrapForwardValueHelper(),
        isForwardValue: new IsForwardValueHelper(),
        wrapInput: new WrapInputHelper(),
        unwrapInput: new UnwrapInputHelper(),
        isInput: new IsInputHelper(),
        isIterable: new IsIterableHelper(),
        wrapIteratorResult: new WrapIteratorResultHelper(),
        unwrapIteratorResult: new UnwrapIteratorResultHelper(),
        isIteratorResult: new IsIteratorResultHelper(),
        wrapIterableIterator: new WrapIterableIteratorHelper(),
        unwrapIterableIterator: new UnwrapIterableIteratorHelper(),
        isIterableIterator: new IsIterableIteratorHelper(),
        wrapMap: new WrapMapHelper(),
        unwrapMap: new UnwrapMapHelper(),
        isMap: new IsMapHelper(),
        wrapMapStorage: new WrapMapStorageHelper(),
        unwrapMapStorage: new UnwrapMapStorageHelper(),
        isMapStorage: new IsMapStorageHelper(),
        wrapOutput: new WrapOutputHelper(),
        unwrapOutput: new UnwrapOutputHelper(),
        isOutput: new IsOutputHelper(),
        wrapSet: new WrapSetHelper(),
        unwrapSet: new UnwrapSetHelper(),
        isSet: new IsSetHelper(),
        wrapSetStorage: new WrapSetStorageHelper(),
        unwrapSetStorage: new UnwrapSetStorageHelper(),
        isSetStorage: new IsSetStorageHelper(),
        wrapTransaction: new WrapTransactionHelper(),
        unwrapTransaction: new UnwrapTransactionHelper(),
        isTransaction: new IsTransactionHelper(),
        export: (options) => new ExportHelper(options),
        exportSingle: (options) => new ExportSingleHelper(options),
        getModule: (options) => new GetModuleHelper(options),
        getCurrentModule: new GetCurrentModuleHelper(),
        getModules: new GetModulesHelper(),
        addEmptyModule: new AddEmptyModuleHelper(),
        createGlobalObject: new CreateGlobalObjectHelper(),
        getArgument: new GetArgumentHelper(),
        getGlobalProperty: (options) => new GetGlobalPropertyHelper(options),
    };
};

//# sourceMappingURL=createHelpers.js.map
